import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRuler20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRuler20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 3v6h4V8H7.975a.75.75 0 0 1 0-1.5H9.5v-1H7.975a.75.75 0 0 1 0-1.5H9.5V3a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0-.5.5M4 3v6H3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-1h6a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-6V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2m5.5 13h-4v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm1.5-1.5h6a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1.5v1.525a.75.75 0 0 1-1.5 0V10.5h-1.5v1.525a.75.75 0 0 1-1.5 0V10.5H9.5v1.525a.75.75 0 0 1-1.5 0V10.5H6.5v1.525a.75.75 0 0 1-1.5 0V10.5H3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRuler20);
